(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-allocation"] && !Shopify.designMode) return;
  try {
    
      function initProductSliders() {
        const productContainers = document.querySelectorAll('.collection-products');

        productContainers.forEach(container => {
          const dotsWrapper = container.parentElement.querySelector('[data-dots]');
          const cards = container.querySelectorAll('.product-card');
          if (!dotsWrapper || cards.length === 0) return;

          const containerWidth = container.offsetWidth;
          const cardWidth = cards[0].getBoundingClientRect().width;
          const visibleCount = Math.floor(containerWidth / cardWidth) || 1;
          const totalPages = Math.ceil(cards.length / visibleCount);

          dotsWrapper.innerHTML = '';

          for (let i = 0; i < totalPages; i++) {
            const dot = document.createElement('span');
            dot.className = 'dot' + (i === 0 ? ' active' : '');
            dot.dataset.page = i;
            dotsWrapper.appendChild(dot);
          }

          const dots = dotsWrapper.querySelectorAll('.dot');

          container.addEventListener('scroll', () => {
            const page = Math.round(container.scrollLeft / cardWidth);
            dots.forEach((dot, i) => {
              dot.classList.toggle('active', i === page);
            });
          });

          dots.forEach(dot => {
            dot.addEventListener('click', () => {
              const pageIndex = parseInt(dot.dataset.page);
              container.scrollTo({
                left: pageIndex * cardWidth,
                behavior: 'smooth'
              });
            });
          });
        });
      }

      // Execute when DOM is ready and after Shopify loads dynamic content
      document.addEventListener('shopify:section:load', initProductSliders);
     document.addEventListener('DOMContentLoaded', initProductSliders);
    document.addEventListener('shopify:section:load', initProductSliders);
  
  } catch(e) { console.error(e); }
})();
})();
